module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_albano_sm-ae3d3133b8b5b486cfcdc214606031cd.png";